import { useEffect } from 'react';
import { useClerk } from '@clerk/clerk-react';

export default function SignOut() {
  const { signOut } = useClerk();

  useEffect(() => {
    const handleSignOut = async () => {
      try {
        await signOut();
        // Redirect to landing page after sign out
        window.location.href = '/landing.html';
      } catch (error) {
        console.error('Sign out error:', error);
        // Still redirect even if there's an error
        window.location.href = '/landing.html';
      }
    };

    handleSignOut();
  }, [signOut]);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      fontFamily: "'Inter', sans-serif"
    }}>
      <div style={{ textAlign: 'center' }}>
        <h2 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: '24px',
          color: '#19285c',
          marginBottom: '16px'
        }}>
          Signing out...
        </h2>
        <p style={{ color: '#666' }}>
          Please wait while we sign you out.
        </p>
      </div>
    </div>
  );
}
